<template>
  <!--变更记录-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '变更日期',
          dataIndex: 'changeDate',
          key: 'changeDate',
          width: 150,
        },
        {
          title: '变更事项',
          dataIndex: 'changeItem',
          key: 'changeItem',
          width: 300,
        },
        {
          title: '变更前',
          dataIndex: 'beforeChangeContent',
          key: 'beforeChangeContent',
          width: 300,
        },
        {
          title: '变更后',
          dataIndex: 'afterChangeContent',
          key: 'afterChangeContent',
          width: 300,
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
